<template>
  <div class="shadow-box">
    <h6 class="section-title mb-2">Manifest</h6>
    <pre
      class="payload mb-2"
      data-test="examination-manifest-payload"
    ><code>{{ prettyJson }}</code></pre>
  </div>
</template>

<script>
export default {
  name: "ExaminationManifestBox",
  props: { manifest: { type: String, required: true } },
  computed: {
    prettyJson() {
      try {
        const parsed = JSON.parse(this.manifest);
        return JSON.stringify(parsed, null, 2);
      } catch (e) {
        return this.manifest;
      }
    },
  },
};
</script>

<style scoped>
.section-title {
  font-weight: 600;
  font-size: 0.95rem;
  color: #212529;
}
.payload {
  background: #0f172a;
  color: #e2e8f0;
  border-radius: 0.375rem;
  padding: 0.75rem 1rem;
  max-height: 50vh;
  overflow: auto;
  font-size: 0.825rem;
  margin: 0;
}
</style>
